import React from 'react';
import { Container, Icon } from 'semantic-ui-react';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <Container>
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-brand">
              <img
                src={process.env.PUBLIC_URL + '/logo.png'}
                alt="NRC Investments"
                className="footer-logo"
              />
            </div>

            <div className="footer-contact">
              <h4>Contact Us</h4>
              <div className="contact-item">
                <Icon name="mail" />
                <a href="mailto:info@nrcinvestmentsllc.com">info@nrcinvestmentsllc.com</a>
              </div>
              <div className="contact-item">
                <Icon name="phone" />
                <a href="tel:+13072007867">+(1) 307-200-7867</a>
              </div>
            </div>

            <div className="footer-links">
              <h4>Legal</h4>
              <a href="https://www.nrcinvestments.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
              <a href="https://www.nrcinvestments.com/terms-conditions" target="_blank" rel="noopener noreferrer">
                Terms & Conditions
              </a>
            </div>
          </div>

          <div className="footer-disclaimer">
            <p>
              This website is neither an offer to sell nor a solicitation of an offer to buy securities.
              It is for information purposes only and designed for accredited investors.
            </p>
          </div>

          <div className="footer-bottom">
            <p>Copyright &copy; {currentYear} | NRC Investments, LLC. All rights reserved.</p>
          </div>
        </div>
      </Container>
    </footer>
  );
};
